import { TipoPublicacion } from '../models/tipo-publicacion';
import { SeccionPublicacion } from '../models/seccion-publicacion';

export class Publicacion {
  public id: number;
  public titulo: string;
  public subtitulo: string;
  public fecha: string;
  public texto: string;
  public imagen: string;
  public destacado: boolean;
  public link: string;

  public imagenes: [];
  public tipo: TipoPublicacion = new TipoPublicacion();
  public seccion: SeccionPublicacion = new SeccionPublicacion();

  constructor() { }
}
